import { render, staticRenderFns } from "./OrderCode.vue?vue&type=template&id=18d19ab6&"
import script from "./OrderCode.vue?vue&type=script&lang=js&"
export * from "./OrderCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d19ab6')) {
      api.createRecord('18d19ab6', component.options)
    } else {
      api.reload('18d19ab6', component.options)
    }
    module.hot.accept("./OrderCode.vue?vue&type=template&id=18d19ab6&", function () {
      api.rerender('18d19ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/Items/OrderCode.vue"
export default component.exports